import { lazy } from 'react'
import { Route, Switch } from '@hfs/react-router'
import { getRoute } from '@hfs/website/utils/getRoute'

export const NewsRoutes = () => (
  <Switch>
    <Route
      component={lazy(async () => {
        const { News } = await import(
          /* webpackPrefetch: true, webpackChunkName: "News" */ '@hfs/website/react/pages/public/News'
        )

        return {
          default: News,
        }
      })}
      exact
      path={getRoute('/news')}
    />
  </Switch>
)
